<template>
  <div class="w-100">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />

    <div>
      <v-btn
        class="float-right"
        color="success"
        flat
        title="Neuen Kontakt erfassen"
        @click="createNew"
      >
        <i class="fas fa-plus mr-3" /> Erfassen
      </v-btn>

      <div class="row">
        <div class="col-4">
          <v-text-field
            id="searchInput"
            v-model="searchTerm"
            append-icon="fas fa-search"
            class="search--input"
            label="Nach Kontakt suchen..."
          />
        </div>
        <div class="col-2">
          <v-select
            v-model="adActiveStateFilter"
            label="Status"
            :items="adStateOptions"
          />
        </div>
      </div>

      <div
        class="mt-5 ml-3"
        style="width: 100%"
      >
        <b-select
          v-model="resultsPerPage"
          class="custom-select ml-1"
          style="width: 62px; height: 31px; font-size: 12px"
        >
          <option :value="10">
            10
          </option>
          <option :value="25">
            25
          </option>
          <option :value="50">
            50
          </option>
          <option :value="100">
            100
          </option>
        </b-select>
        <label
          style="font-weight: bold; margin-left: 3px"
        >Anzahl Resultate</label>
        <b-pagination
          v-model="currentPage"
          :per-page="resultsPerPage"
          :total-rows="totalNumberOfContracts"
          class="float-right mr-3"
          first-text="<<"
          last-text=">>"
          next-text="Nächste"
          prev-text="Vorherige"
        />
      </div>
      <v-flex
        v-if="isLoading"
        justify-center
      >
        <u-loader />
      </v-flex>
      <table
        v-else
        class="w-100 contactsOverview ml-2 mt-4"
      >
        <thead>
          <tr>
            <th>Anrede</th>
            <th>Nachname</th>
            <th>Vorname</th>
            <th>Organisation</th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Mobile</th>
            <th>Status</th>
            <th>Aktion</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="contact in contacts"
            :key="contact.id"
            :style="{
              'background-color': contact.inactive
                ? 'rgba(255, 0, 0, 0.4)'
                : '',
            }"
          >
            <td>{{ getAnredeById(contact.formOfAddressId) }}</td>
            <td>{{ contact.lastName }}</td>
            <td>{{ contact.firstName }}</td>
            <td>
              {{
                contact.organisation
                  ? contact.organisation.organisationContents[0].name
                  : ""
              }}
            </td>
            <td>{{ contact.email }}</td>
            <td>{{ contact.phone }}</td>
            <td>{{ contact.mobilePhone }}</td>
            <td class="text-danger">
              {{ contact.inactive ? "Inaktiv" : "" }}
            </td>
            <td>
              <v-btn
                color="#007bff"
                dark
                fab
                small
                title="Bearbeiten"
                @click="editContact(contact.id)"
              >
                <i class="fas fa-edit" />
              </v-btn>
              <v-btn
                color="#e72b37"
                dark
                fab
                small
                title="Löschen"
                @click="deleteContact(contact.id)"
              >
                <i class="fas fa-trash" />
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {
  GetContacts,
  GetFormOfAddress,
  DeleteContacts,
  GetAdActiveStateEnum,
} from "@/services/user.crm.service";

export default {
  data() {
    return {
      isLoading: false,
      errorObject: null,
      searchTerm: "",
      contacts: [],
      totalNumberOfContracts: 0,
      currentPage: 1,
      resultsPerPage: 25,
      sortOrder: 0,
      sortedProperty: "",
      allAnreden: [],
      allOrganisations: [],
      adStateOptions: [],
      adActiveStateFilter: 0,
    };
  },
  watch: {
    searchTerm() {
      this.getContacts();
    },
    currentPage() {
      this.getContacts();
    },
    resultsPerPage() {
      this.currentPage = 1;
      this.getContacts();
    },
    adActiveStateFilter() {
      this.getContacts();
    },
  },
  created() {
    if (this.$route.path === "/contacts") {
      this.getFormOfAddress();
      localStorage.removeItem("contactObject");
    }
  },
  methods: {
    createNew() {
      this.$router.push({
        path: "contacts/create",
      });
    },
    editContact(contactId) {
      this.$router.push({
        path: "contacts/edit?contact=" + contactId,
      });
    },
    getContacts() {
      this.isLoading = true;
      GetContacts(
        this.resultsPerPage,
        this.currentPage,
        this.searchTerm,
        this.sortedProperty,
        this.sortOrder,
        this.adActiveStateFilter,
        (response) => {
          this.contacts = response.contacts;
          this.totalNumberOfContracts = response.numberOfItems;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    deleteContact(contactId) {
      this.isLoading = true;
      DeleteContacts(
        contactId,
        () => {
          this.getContacts();
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    //Weitere Abfragen, welche bnötigt werden
    getFormOfAddress() {
      this.isLoading = true;
      this.errorObject = null;

      GetFormOfAddress(
        (response) => {
          this.allAnreden = response;

          this.getAdStateOptions();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getAdStateOptions() {
      this.isLoading = true;
      this.errorObject = null;

      GetAdActiveStateEnum(
        (response) => {
          let options = [];
          Object.keys(response).forEach((key) => {
            options.push({
              value: key,
              text: response[key],
            });
          });
          this.adStateOptions = options;
          this.adActiveStateFilter = 0;
          this.getContacts();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getAnredeById(anredenId) {
      if (anredenId) {
        return this.allAnreden.filter(
          (anrede) => anrede.formOfAddressId === anredenId,
        )[0].value;
      } else {
        return "";
      }
    },
    getOrganisationById(organisationId) {
      if (organisationId) {
        return this.allOrganisations.filter(
          (oragnisation) => oragnisation.id === organisationId,
        )[0].name;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.contactsOverview {
  font-size: small;
  table-layout: fixed;
}

.contactsOverview thead th:nth-child(1) {
  width: 5%;
}

.contactsOverview thead th:nth-child(2) {
  width: 10%;
}

.contactsOverview thead th:nth-child(3) {
  width: 10%;
}

.contactsOverview thead th:nth-child(4) {
  width: 20%;
}

.contactsOverview thead th:nth-child(5) {
  width: 15%;
}

.contactsOverview thead th:nth-child(6) {
  width: 10%;
}

.contactsOverview thead th:nth-child(7) {
  width: 10%;
}

.contactsOverview thead th:nth-child(8) {
  width: 10%;
}

.contactsOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.contactsOverview td,
.contactsOverview th {
  padding: 8px 4px;
}

/deep/ .page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #e72b37;
  border-color: red;
}

/deep/ .page-link:hover {
  z-index: 2;
  color: red;
  text-decoration: none;
  background-color: #fdd;
  border-color: #fdd;
}

/deep/ a:hover {
  color: #0056b3;
  text-decoration: underline;
}

/deep/ .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: red;
  background-color: rgb(255, 255, 255);
  border: 1px solid #dee2e6;
}

.custom-select.filled-input {
  border-bottom-color: red;
  background-color: #ededed;
  font-weight: bold;
  color: #333;
}

.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #aaa;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  padding: 0 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus {
  outline: none;
  border-bottom: 2px solid #333;
  color: #333;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

/* CSS für den Pfeil */

.custom-select:after {
  content: "";

  position: absolute;

  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  margin-top: -4px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus:after {
  margin-top: -2px;
  border-top: 5px solid #fdd;
  transform: rotate(180deg);
}
</style>
